// 다시 보지 않기 UI
import { Checkbox } from "antd";
import setCookie from "../cookie/setCookie";
import { FormattedMessage,   injectIntl } from "react-intl";
import "../App.css";

const closePopUp = (cookieName, cookieValue, expiredays, closeFunc, turnOffCheckBox) => {
  if (turnOffCheckBox) {
    expiredays = new Date();
  }
  setCookie(cookieName, cookieValue, expiredays);
  closeFunc();
};

let ClosePopUpCheckboxUI = (props) => (
  <div className="close-popup-checkbox-wapper">
    <Checkbox onChange={() => closePopUp(props.cookieName, props.cookieValue, props.expiredays, props.closeFunc, props.isExistedCookie)} checked={props.isExistedCookie} style={props.style}>
      <FormattedMessage id={"ClosePopupCheckbox.text"} defaultMessage={"Don't show this again"} />
    </Checkbox>
  </div>
);

 
ClosePopUpCheckboxUI = injectIntl(ClosePopUpCheckboxUI);

export default ClosePopUpCheckboxUI;
